module.exports = __webpack_public_path__ + "assets/images/covid-hits-home-6.jpg?v=48ac27b3";